<template>
  <div class="columns">
    <div class="column is-6 chart-container is-relative">
      <div style="min-height: 470px;">
          <TrfSimpleSlider 
          ref="graficosTipo" 
          titulo="Tarefas por tipo" 
          maxFrameHeight="356px" 
          v-if="totalizadorPorTipo.totalDePaginas != 0" 
          :emitirEventosDeControle="true" 
          @slideChange="async (pagina) => await carregarPaginaDeTipo(pagina, false)">

          <div v-for="n in totalizadorPorTipo.totalDePaginas" :key="n">
            <GChart
              v-if="!!totalizadorPorTipo.dados[n-1]"
              :type="totalizadorPorTipo.chartType"
              :data="totalizadorPorTipo.dados[n-1]"
              :options="totalizadorPorTipo.chartOptions"
              :events="totalizadorPorTipo.chartEvents"
            />
            <div v-else-if="primeiroCarregamento" class="chart-page-placeholder is-relative" style="height:356px;">
              <TrfGlobalLoader type="overlay"/>
            </div>
          </div>
        </TrfSimpleSlider>
        <div class="is-flex is-flex-direction-column" style="height: 100%;" v-else-if="!primeiroCarregamento">
            <div class="is-justify-content-center">
                <p class="has-text-centered is-size-5">Tarefas por tipo</p>
            </div>
            <div class="is-flex is-flex-grow-1 is-justify-content-center is-align-items-center">
                <p class="has-text-centered">Não há dados</p>
            </div>
        </div>
      </div>

      <TrfGlobalLoader type="overlay" v-if="primeiroCarregamento || (atendimentosEmAtraso.reloading && totalizadorPorTipo.reloading && this.totalizadorPorTipo.dados.length > 0)"/>

      <div class="is-flex is-flex-direction-column" style="height: 400px;">
        <div v-if="!primeiroCarregamento">
          <p class="has-text-centered is-size-5">Monitoramento dos atendimentos em atraso</p>
        </div>
        <GChart
            v-if="!primeiroCarregamento && dadosAtendimentosEmAtrasoTratado.length > 0"
            :type="atendimentosEmAtraso.chartType"
            :data="dadosAtendimentosEmAtrasoTratado"
            :options="atendimentosEmAtraso.chartOptions"
            :events="atendimentosEmAtraso.chartEvents"
          />
        <div class="is-flex is-flex-grow-1 is-justify-content-center is-align-items-center" v-else-if="!primeiroCarregamento">
          <p class="has-text-centered">Não há dados</p>
        </div>
      </div>

    </div>
    
    <div class="column is-6 chart-container is-relative is-flex is-flex-direction-column">
      <div style="height: 470px">
        <div v-if="dadosTotalizadorTratado.length > 0 && !primeiroCarregamento">
          <p class="has-text-centered is-size-5">Andamento das entregas</p>
        </div>
        <GChart
          v-if="dadosTotalizadorTratado.length > 0
                  && (dadosTotalizadorTratado[1][1] != '0'
                    || dadosTotalizadorTratado[2][1] != '0'
                    || dadosTotalizadorTratado[3][1] != '0'
                  )"
          :type="totalizadorDeTarefas.chartType"
          :data="dadosTotalizadorTratado"
          :options="totalizadorDeTarefas.chartOptions"
          :events="totalizadorDeTarefas.chartEvents"
          ref="totalizadorDeTarefasChart"
        />
        <div style="height: 100%;" class="is-align-items-center is-flex-grow-1 is-justify-content-center is-flex mt-2" v-if="!primeiroCarregamento
                                                                                                        && (dadosTotalizadorTratado[1][1] == '0'
                                                                                                        && dadosTotalizadorTratado[2][1] == '0' 
                                                                                                        && dadosTotalizadorTratado[3][1] == '0')" >
            <p class="has-text-centered">Não há dados</p>
        </div>
      </div>
      <TrfGlobalLoader type="overlay" v-if="primeiroCarregamento || totalizadorDeTarefas.reloading 
                                                            && desempenhoDasEntregas.reloading
                                                            && dadosTotalizadorTratado.length > 0"/>

      <div class="is-flex is-flex-direction-column" style="height: 400px;">
        <div v-if="!primeiroCarregamento">
          <p class="has-text-centered is-size-5">Desempenho das entregas: análise de prazos</p>
        </div>
        <GChart
          v-if="!primeiroCarregamento 
                    && dadosDesempenhoEntregasTratado.length > 0
                    && (dadosDesempenhoEntregasTratado[1][1] != '0' 
                        ||dadosDesempenhoEntregasTratado[2][1] != '0')"
          :type="desempenhoDasEntregas.chartType"
          :data="dadosDesempenhoEntregasTratado"
          :options="desempenhoDasEntregas.chartOptions"
          :events="desempenhoDasEntregas.chartEvents"
          ref="desempenhoDasEntregasChart"
        />
        <div class="is-flex is-flex-grow-1 is-justify-content-center is-align-items-center" v-else-if="!primeiroCarregamento">
            <p class="has-text-centered">Não há dados</p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { toastUtils } from '../../../../util/toast.utils';
import TrfSimpleSlider from '../../../../components/SimpleSlider';
import { GChart } from 'vue-google-charts'
import {totalizadoresPorTipoService} from '../../../../service/totalizadores-por-tipo-service';
import TrfGlobalLoader from '../../../../components/GlobalLoader';
import { configuracoesStore } from "../../../../stateManagement/configuracoes";

export default {
  name: "DashboardGestorGraficos",
  components: {
    TrfSimpleSlider,
    TrfGlobalLoader,
    GChart
  },
  props: {
    filtros: {},
    dadosDoTotalizador: null,
    dadosDesempenhoDasEntregas: null,
    dadosAtendimentosEmAtraso: null
  },
  data() {
    return {
      primeiroCarregamento: true,
      paginaPorTipo: 0,
      totalizadorPorTipo: {
        titulos: ['Tipo', 'A fazer', 'Atrasada', 'Risco de Multa', 'Concluído', 'Paralisada'],
        dados: [],
        chartType: 'ColumnChart',
        chartOptions: {
          hAxis: {
            slantedText: true,
            slantedTextAngle: 50,
            maxTextLines: 2,
            baseline: 0
          },
          vAxis: {
            logScale: true,
            scaleType: "log",
            baseline: 0,
            minorGridlines: {
              count: 0
            }
          },
          colors: ['#5692E6', '#E33B3C', '#C8B71B', '#32AA45', '#666666', '#3186AA'],
          chartArea: { width: '50%', bottom: 100, right: 0, left: 50 },
          width: "100%",
          height: 350,
          fontName:"Droid Sans, Helvetica, Arial, sans-serif"
        },
        chartEvents: {
          click: (event) => {
            const indexes = event.targetID.split('#');
            const indexStatus = parseInt(indexes[1]);
            const indexDado = parseInt(indexes[2]);
            const statusString = this.totalizadorPorTipo.titulos[indexStatus+1];
            const nomeString = this.totalizadorPorTipo.dados[this.paginaPorTipo - 1][indexDado+1][0];
            const targetHandler = this.adquirirHandlerTotalizadorDeTarefas(statusString);
            this.$emit('action:iniciarModal',{nomeString,targetHandler})
          }
        },
        itensPorPagina: 5,
        totalDePaginas: 0,
        reloading: false
      },
      totalizadorDeTarefas: {
        titulos: ["Status", "Quantidade de Tarefas"],
        dados: this.dadosDoTotalizador,
        chartType: 'PieChart',
        chartOptions: {
          backgroundColor: 'transparent',
          width: "100%",
          height: 350,
          slices: [{color: '#5692e6'}, {color: '#e33b3c'}, {color: '#32aa45'},{color: '#666666'},{color: '#547faa'}],
          sliceVisibilityThreshold: 0
        },
        chartEvents: {
          click: (event) => {
            const targetId = event.targetID;
            if(!this.isCliqueTotalizadorDeTarefasValido(targetId)) return;
            const targetIndex = parseInt(targetId.split('#')[1]);
            const targetName = this.dadosTotalizadorTratado[targetIndex+1][0];
            const targetHandler = this.adquirirHandlerTotalizadorDeTarefas(targetName)
            this.$emit('action:iniciarModal', targetHandler)
          }
        },
        reloading: false
      },
      desempenhoDasEntregas: {
        titulos: ["Status", "Quantidade de Tarefas"],
        dados: this.dadosDesempenhoDasEntregas,
        chartType: 'PieChart',
        chartOptions: {
          backgroundColor: 'transparent',
          width: "100%",
          height: 350,
          slices: [{color: '#e33b3c'}, {color: '#32aa45'}],
          sliceVisibilityThreshold: 0
        },
        chartEvents: {
          click: (event) => {
            const targetId = event.targetID;
            if (!this.isCliqueDesempenhoDasEntregasValido(targetId)) return;
            const targetIndex = parseInt(targetId.split('#')[1]);
            const targetName = this.dadosDesempenhoEntregasTratado[targetIndex+1][0];
            const targetHandler = this.adquirirHandlerTotalizadorDeTarefas(targetName)
            this.$emit('action:iniciarModal', targetHandler)
          }
        },
        reloading: false
      },
      atendimentosEmAtraso: {
        dados: this.dadosAtendimentosEmAtraso,
        chartType: 'BarChart',
        chartOptions: {
          hAxis: {
            title: 'Quantidade de Atendimentos',
            titleTextStyle: {
              italic: false
            }
          },
          bars: 'horizontal',
          colors: ['#e33b3c'],
          legend: { position: 'none' },
          width: 700,
          height: 350,
          bar: { groupWidth: '35%' }
        },
        chartEvents: {
          click: (event) => {
            const targetId = event.targetID;
            if (!this.isCliqueAtendimentosAtrasadosValido(targetId)) return;
            const targetIndex = parseInt(targetId.split('#')[2]);
            const targetName = this.dadosAtendimentosEmAtrasoTratado[targetIndex+1][0];
            this.$emit('action:iniciarModal', targetName)
          }
        },
        reloading: false
      }
    };
  },
  methods: {
    async adquirirTotalDePaginasPorTipo() {
      const baseDeFiltro = Object.assign({}, this.filtrosConvertidos);
      baseDeFiltro.limit = 1;
      const request = await totalizadoresPorTipoService.listar(baseDeFiltro);
      const totalDeItens = request.totalDeItens;
      const totalDePaginas = Math.ceil(totalDeItens / this.totalizadorPorTipo.itensPorPagina);
      const totalDePaginasInt = parseInt(totalDePaginas)
      this.totalizadorPorTipo.totalDePaginas = totalDePaginasInt;
      this.primeiroCarregamento = false; 
    },
    async carregarPaginaDeTipo(pagina = 1, resetar = false) {
      this.paginaPorTipo = pagina;
      if(resetar) {
        this.totalizadorPorTipo.reloading = true;
        const total = await this.adquirirTotalDePaginasPorTipo();
        this.totalizadorPorTipo.dados = [];
        if(this.totalizadorPorTipo.totalDePaginas != 0 && !this.totalizadorPorTipo.reloading) {
          this.$refs.graficosTipo._fazerTransicao(1, true);
        }
      };

      if(!!this.totalizadorPorTipo.dados[pagina-1]) return;

      const filtroBase = Object.assign({}, this.filtrosConvertidos);
      filtroBase.limit = this.totalizadorPorTipo.itensPorPagina;
      filtroBase.pagina = pagina;

      try {
        const request = await totalizadoresPorTipoService.listar(filtroBase);
        const itensPaginados = request.data[0].tipo;
        if(Array.isArray(itensPaginados)) {
          itensPaginados.unshift(this.titulosPorTipoTratados);
          this.totalizadorPorTipo.dados[pagina-1] = itensPaginados;
        }
      } catch(e) {
        toastUtils.dangerToast(`Não foi possível carregar o gráfico por tipo, página ${pagina}.\n Tente novamente mais tarde.`);
        console.error(`Erro ao carregar página ${pagina}:`, e)
      }
    },
    async carregarTodasPorTipo() {
      const total = await this.adquirirTotalDePaginasPorTipo();
      this.totalizadorPorTipo.dados = [];
      for(let pagina = 1; pagina < this.totalizadorPorTipo.totalDePaginas+1; pagina++) {
        const filtroBase = Object.assign({}, this.filtrosConvertidos);
        filtroBase.limit = this.totalizadorPorTipo.itensPorPagina;
        filtroBase.pagina = pagina;
        const request = await totalizadoresPorTipoService.listar(filtroBase);
        const itensPaginados = request?.data[0]?.tipo;
        if(Array.isArray(itensPaginados)) {
          itensPaginados.unshift(this.titulosPorTipoTratados);
          this.totalizadorPorTipo.dados.push(itensPaginados);
        } else {
          console.error(`Erro na requisição da pagina ${pagina}`);
          break;
        }
      };
    },
    isCliqueTotalizadorDeTarefasValido(targetId) {
      return (targetId.indexOf('#') && !isNaN(parseInt(targetId.split('#')[1])));
    },
    isCliqueDesempenhoDasEntregasValido(targetId) {
      return (targetId.indexOf('#') && !isNaN(parseInt(targetId.split('#')[1])));
    },
    isCliqueAtendimentosAtrasadosValido(targetId) {
      return (targetId.indexOf('#') && !isNaN(parseInt(targetId.split('#')[1])));
    },
    toggleLoaderTotalizadorDeTarefas(valor) {
      valor = valor != undefined? valor : !this.totalizadorDeTarefas.reloading
      this.totalizadorDeTarefas.reloading = valor;
    },
    toggleLoaderTotalizadorPorTipoDeTarefas(valor) {
      valor = valor != undefined? valor : !this.totalizadorPorTipo.reloading
      this.totalizadorPorTipo.reloading = valor;
    },
    toggleLoaderDesempenhoDasEntregas(valor) {
      valor = valor != undefined? valor : !this.desempenhoDasEntregas.reloading
      this.desempenhoDasEntregas.reloading = valor;  
    },
    toggleLoaderAtendimentosEmAtraso(valor) {
      valor = valor != undefined? valor : !this.atendimentosEmAtraso.reloading
      this.atendimentosEmAtraso.reloading = valor;
    },
    adquirirHandlerTotalizadorDeTarefas(nome) {
      switch(nome) {
        case 'A fazer':
          return 'pendente'
        case 'Atrasada':
          return 'atrasada'
        case 'Concluído':
        case 'Concluido':
          return 'concluido'
        case 'Enviado':
          return 'enviado'
        case 'Risco de Multa':
          return 'multa'
        case 'Concluída no prazo':
          return 'concluidasNoPrazo'
        case 'Concluída em atraso':
          return 'concluidasEmAtraso'
        case 'Paralisada':
          return 'paralisada'
        default:
          return ''
      }
    }
  },
  computed: {
    filtrosConvertidos() {
      if(!!!this.filtros) return {};
      const filtroBase = Object.assign({}, this.filtros);
      filtroBase.enviada = configuracoesStore.GerarBaixaPorLeitura;
      delete filtroBase["sort[ASC]"];
      delete filtroBase.status;
      delete filtroBase["tarefaCliente[is]"];
      filtroBase["tarefaCliente"] = false;
      return filtroBase
    },
    titulosPorTipoTratados() {
      const titulosTratados = [...this.totalizadorPorTipo.titulos];
      if(configuracoesStore.GerarBaixaPorLeitura) {
        titulosTratados.push("Enviado");
      }
      return titulosTratados;
    },
    dadosTotalizadorTratado() {
      if(!!!this.dadosDoTotalizador) return [];

      const dados = this.dadosDoTotalizador;
      const totalizador = [
        [...this.totalizadorDeTarefas.titulos],
        ["A fazer", dados.aVencer],
        ["Atrasada", dados.atrasadas],
        ["Concluído", dados.concluidas],
        ["Paralisada", dados.paralisadas]
      ]
      if(this.GerarBaixaPorLeitura && dados.enviado != undefined) {
        totalizador.push(["Enviado", dados.enviado])
      }

      return totalizador;
    },
    dadosDesempenhoEntregasTratado() {
      if((this.dadosDesempenhoDasEntregas.concluidasEmAtraso == "0" 
            && this.dadosDesempenhoDasEntregas.concluidasNoPrazo == "0")) return [];
      const dados = this.dadosDesempenhoDasEntregas;
      const totalizador = [
        ["Status", "Quantidade de Tarefas"],
        ["Concluída em atraso", dados.concluidasEmAtraso],
        ["Concluída no prazo", dados.concluidasNoPrazo]
      ]

      return totalizador;
    },
    dadosAtendimentosEmAtrasoTratado() {

      const semDados = this.dadosAtendimentosEmAtraso.umADoisDias == "0" 
                        && this.dadosAtendimentosEmAtraso.tresACincoDias == "0" 
                        && this.dadosAtendimentosEmAtraso.seisAteDezDias == "0" 
                        && this.dadosAtendimentosEmAtraso.onzeAteQuinzeDias == "0" 
                        && this.dadosAtendimentosEmAtraso.maisDeQuinzeDias == "0" 


      if((semDados)) return [];

      const dados = this.dadosAtendimentosEmAtraso;

      const totalizador = [
        ["", "Quantidade de Atendimentos",{ role: 'tooltip', p: { html: true } }],
        ["1-2 dias", dados.umADoisDias,`Atrasada de 1 a 2 dias: ${dados.umADoisDias}`],
        ["3-5 dias", dados.tresACincoDias,`Atrasada de 3 a 5 dias: ${dados.tresACincoDias}`],
        ["6-10 dias", dados.seisAteDezDias,`Atrasada de 6 a 10 dias: ${dados.seisAteDezDias}`],
        ["11-15 dias", dados.onzeAteQuinzeDias,`Atrasada de 11 a 15 dias: ${dados.onzeAteQuinzeDias}`],
        ["> 15 dias", dados.maisDeQuinzeDias,`Atrasada acima de 15 dias: ${dados.maisDeQuinzeDias}`]
      ]
      
      return totalizador;
    },
    GerarBaixaPorLeitura() {
      return configuracoesStore.GerarBaixaPorLeitura
    },
  }
};
</script>
<style lang="scss">
svg > g > g.google-visualization-tooltip { pointer-events: none }
</style>